//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { customRegion_queryAll, lookIntermediary, getSelfItemList } from '@/api/baseDataManage';
import { getAgencyLisy, getCompanyList, getEngageList, getLimitList, getProductList } from '@/api/baseDate';
import { getCheckVerifyPermissions, getApplicantInfo, saveInfo, baseInfo, applyInfo, getInfo, getRecord, getCountry as _getCountry, promiseData, coinData, upLoads, deleteUpLoads, BASE, ECARGO_PATH } from '@/api/apis';
import { excleCargoDownload_biaodi, imageUploads_del, imageUploads_fun } from "@/api/policymanagement";
import $ from "jquery";
import { validateEmail } from "../../libs/common";
export default {
  name: 'InputPolicy',
  data: function data() {
    var validateRequiredFlout = function validateRequiredFlout(rule, value, callback) {
      console.log('value==', value);

      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^\d+(\.\d{1,2})?$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入数字或小数点后两位！'));
        }
      }
    };

    var validateRequiredFlout1 = function validateRequiredFlout1(rule, value, callback) {
      console.log('value==', value);

      if (value == null || value.length === 0) {
        callback();
      } else {
        var reg = /^\d+(\.\d{1,2})?$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入数字或小数点后两位！'));
        }
      }
    };

    var validateInt = function validateInt(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    var validateInt1 = function validateInt1(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback();
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    var validateUpper = function validateUpper(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[A-Z0-9`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]]+$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('只能输入大写字母，数字，和英文字符!'));
        }
      }
    };

    var validatePolicyNo = function validatePolicyNo(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[A-Za-z0-9]+$/;

        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error('只能输入数字和英文字符!'));
        }
      }
    };

    var validatePercent = function validatePercent(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback(new Error('请输入'));
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          if (Number(value) > 100) {
            callback(new Error('占比不允许超过100%'));
          } else {
            callback();
          }
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    var validatePercent1 = function validatePercent1(rule, value, callback) {
      if (value == null || value.length === 0) {
        callback();
      } else {
        var reg = /^[1-9]\d*$/;

        if (reg.test(value)) {
          if (Number(value) > 100) {
            callback(new Error('占比不允许超过100%'));
          } else {
            callback();
          }
        } else {
          callback(new Error('请输入整数!'));
        }
      }
    };

    return {
      // ----start  信用险投保人基本信息入参 以下:
      formData: {
        policyNo: '',
        startDate: '',
        endDate: '',
        premiumCurrency: '',
        premiumCurrencyName: '',
        premiumStart: '',
        premiumEnd: '',
        submitType: '',
        // 提交类型 1、暂存提交 2、提交
        operateType: '1',
        // 操作类型 1、录入  2、修改录入
        applicationNo: '',
        // 投保单申请号 第一次暂存的时候为空
        applidate: '',
        // 非必传  申请日期 提交时后端根据当前时间去设置值
        applicationStatus: '',
        // 投保申请单状态1、暂存2、修复中3、已提交4、保险公司未承保5、保单生效
        insuranceCompanyCode: '',
        // 保险公司代码
        insuranceCompanyName: '',
        // 保险公司名称
        companyCode: '',
        // 投保申请分支机构
        companyName: '',
        // 投保申请分支机构名称
        applicantAccRevManInst: '',
        // 非必传 投保人应收账款管理制度
        applicantInfo: {
          // 投保人信息
          insuredName: '',
          // 企业中文名称
          insuredEnName: '',
          // 企业英文名称
          identifyNumber: '',
          // 统一社会信用代码
          registAddress: '',
          // 注册地址
          businessAddress: '',
          // 营业地址
          companyDate: '',
          // 成立日期
          businessStartDate: '',
          // 营业期限起
          businessEndDate: '',
          // 营业期限止
          businessRange: '',
          // 营业范围
          authPersonName: '',
          // 法人名称
          authPersonIdeType: '',
          // 法人证件类型
          authPersonIdeTypeName: '',
          // 法人证件类型名称
          authPersonIdeNo: '',
          // 法人证件号
          companyType: '',
          // 公司类型
          companyTypeName: '',
          // 非必传 公司类型名称
          businessType: '',
          // 经营性质
          businessNature: '',
          // 经营性质
          businessTypeName: '',
          // 非必传 经营性质名称
          isListed: '',
          // 是否上市公司 // 1是0否
          linkmanName: '',
          // 联系人名称
          linkmanIdeType: '',
          // 联系人证件类型
          linkmanIdeTypeName: '',
          // 非必传 联系人证件类型名称
          linkmanIdeNo: '',
          // 联系人证件号码
          linkmanEmail: '',
          // 联系人邮箱
          businessScope: '',
          // 拟投标业务范围
          businessStartYear: '',
          // 出口业务开始年份
          receiveEmail: '' // 邮件接收对象

        },
        lastTreYearBus: [// {
          //   serialNo:'', //序号
          //   fiscalYear:'', //会计年度
          //   totalExports:'', //出口总额（万美元）
          //   totalCredit:'', // 赊账总额（万美元）
          // }
        ],
        // 近三年历史业务情况
        lastAllSale: [{
          serialNo: '1',
          // 序号
          goodsName: '',
          // 商品名称或服务内容
          salesAmount: '',
          // 销售额（万美元）
          proportion: '',
          // 占比（%）
          preYearSalesAmount: '',
          // 预计未来一年销售额（万美元）
          payWayCode: '',
          // 付款方式代码
          payWayName: '',
          // 非必填 付款方式名称
          avgAccountPeriod: '' // 平均账期（天）

        }],
        // 最近一个完整会计年度出口情况
        lastAllExp: [{
          serialNo: '1',
          countryCode: '',
          //国家代码
          countryName: '',
          //国家名称
          totalExports: '',
          //出口总额（万美元）
          preYearTotalExports: '',
          //预计未来一年出口额（万美元）
          payWayCode: '',
          //付款方式代码
          payWayName: '',
          //付款方式名称
          avgAccountPeriod: '' //平均账期（天）

        }],
        // 最近一个完整会计年度出口情况
        lastRec: [// 最近一年应收账款余额情况
          // {
          //   serialNo:'1',
          //   balanceDate:'',// 日期
          //   receivableBalance:'',//应收账款余额（万美元）
          //   avgAccountPeriod:'',//平均账期（天）
          // }
        ],
        lastAllRec: [// 应收账款余额分布
          // {
          //   serialNo:'1',
          //   receivableBalanceRangeCode:'',//应收账款余额范围代码
          //   receivableBalanceRangeNAme:'',//应收账款余额范围名称
          //   debtorNumber:'',//债务人数目
          //   sumAmount:'',//string	金额（美元）
          //   dataCountEndDate: '数据统计截止日期'
          // }
        ],
        overDue: [// 逾期应收账款
          // {
          //   serialNo:'1',
          //   overDueDaysCode:'',//逾期天数代码
          //   overDueDaysName:'',//逾期天数名称
          //   sumAmount:'',//金额（美元）
          //   proportion:'',//占比（%）
          //   overDueReasonCode:'',//逾期主要原因代码
          //   overDueReasonName:'',//逾期主要原因名称
          //   overDueReasonDes:'',//逾期原因描述
          // }
        ],
        lastTreUnCollect: [// 近三年逾期未收汇整体情况
          // {
          //   serialNo:'1',
          //   fiscalYear:'',//会计年度
          //   uncollectedAmount:'',//未收汇金额（万美元）
          //   uncollectedReasonCode:'',//未收汇原因代码
          //   uncollectedReasonName:'',//未收汇原因名称
          //   debtorNumber:'',//债务人数目
          //   uncollectedRemark:'',//未收汇备注
          // }
        ],
        maxUnCollect: [// { //最大几笔逾期未收汇详情
          //   serialNo:'',
          //   uncollectedDate:'',//时间
          //   debtorName:'',//债务人全称
          //   debtorAddress:'',//债务人地址
          //   countryCode:'',//国家代码
          //   countryName:'',//国家名称
          //   overDueAmount:'',//逾期或损失金额（万美元）
          //   lossReasonCode:'',//损失原因代码
          //   lossReasonName:'',//损失原因名称
          //   lossRemark:'',//备注（处理现状）
          // }
        ],
        insureRange: {
          // 投保范围
          insuredAmount: '',
          // 投保金额（万美元）
          expectStartDate: '',
          // 期望保险起期
          expectEndDate: '',
          // 期望保险止期
          insuranceRange: '',
          // 投保范围
          disputeDealWay: '',
          // 争议处理方式
          otherCaution: '',
          // 其他需要说明事项
          insuredOtherCaution: ''
        },
        mainBuyer: [// { //投保主要买方/开证行清单表
          //   serialNo:'1',
          //   bankName:'',//开户行名称
          //   buyersName:'',//买方名称
          //   totalExports:'',//出口总额（万美元）
          // }
        ]
      },
      // 投保人信息----end
      hasUplaod: false,
      isSureUpload: false,
      // 上传影像按钮的显示与隐藏
      isSelect: false,
      electActive: false,
      userDisable: false,
      firstDate: {
        year: '',
        mouth: '',
        day: ''
      },
      secondDate: {
        year: '',
        mouth: '',
        day: ''
      },
      isUser: false,
      BASE_PATH: BASE + ECARGO_PATH,
      otherDatas: {
        // 影像上传入参
        type: '',
        applicationNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: ''
      },
      otherDatas_1: {
        type: '1',
        applicationNo: '',
        insuranceCompanyCode: '',
        insuranceCompanyName: ''
      },
      fileListOthers: [],
      upLoadFlag: false,
      fileList_1: [],
      // 文件list
      fileList: [],
      // 文件list
      fileLists: [],
      // 文件list
      fileListExport: [],
      // 出口文件list
      rulesData: {
        policyNo: [{
          required: true,
          trigger: 'blur',
          validator: validatePolicyNo
        }],
        selectRule: [{
          required: true,
          message: '请选择',
          trigger: 'change'
        }],
        notInputRule: [{
          required: true,
          trigger: 'blur',
          message: '请输入'
        }],
        numRule: [{
          required: true,
          trigger: 'blur',
          validator: validateInt
        }],
        numRule2: [{
          required: true,
          trigger: 'blur',
          validator: validateInt1
        }],
        percentRule: [{
          required: true,
          trigger: 'blur',
          validator: validatePercent
        }],
        percentRule1: [{
          required: true,
          trigger: 'blur',
          validator: validatePercent1
        }],
        notNullInputRule: [{
          required: true,
          trigger: 'blur',
          validator: validateRequiredFlout
        }],
        notNullInputRule1: [{
          required: true,
          trigger: 'blur',
          validator: validateRequiredFlout1
        }]
      },
      applicantRules: {
        insuredName: [{
          required: true,
          message: '请输入投保人名称',
          trigger: 'blur'
        }],
        businessScope: [{
          required: true,
          message: '请输入拟投保范围',
          trigger: 'blur'
        }]
      },
      checkedItem: [],
      resolveWay: [{
        differ: '仲裁',
        detail: '在北京仲裁委员会仲裁'
      }],
      applicationOpt: [{
        value: '1',
        label: '暂存'
      }, {
        value: '2',
        label: '修复中'
      }, {
        value: '3',
        label: '已提交'
      }, {
        value: '4',
        label: '保险公司未承保'
      }, {
        value: '5',
        label: '保单生效'
      }],
      insureRange: [],
      // 投保范围
      listOpt: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }],
      companyList: [],
      // 保险公司集合
      attAgencyList: [],
      // 分支机构
      insureApplyRecord: [],
      // 申请单流转记录
      activeName: 'first',
      idCardList: [],
      // 证件类型
      country: [],
      fileBitList: [],
      dialogImageUrl: '',
      salesmanList: [],
      dialogVisible: false,
      checked: false,
      paymentWay: [{
        codeCode: '1',
        codeCname: '信用证(LC)'
      }, {
        codeCode: '2',
        codeCname: '放账(OA)'
      }, {
        codeCode: '3',
        codeCname: 'D/P'
      }, {
        codeCode: '4',
        codeCname: 'DA'
      }, {
        codeCode: '5',
        codeCname: '预付款'
      }, {
        codeCode: '6',
        codeCname: '其他'
      }],
      // 付款方式
      badReason: [{
        codeCode: 'A',
        codeCname: '破产'
      }, {
        codeCode: 'B',
        codeCname: '拖欠'
      }, {
        codeCode: 'C',
        codeCname: '拒绝受领货物'
      }, {
        codeCode: 'D',
        codeCname: '贸易纠纷'
      }, {
        codeCode: 'E',
        codeCname: '政治风险'
      }, {
        codeCode: 'F',
        codeCname: '其他(请详细说明)'
      }],
      // 损失原因
      businessNatures: [],
      // 经营性质
      identifyType: [],
      // 法人证件类型
      companyType: [],
      // 公司类型
      allDisabled: false,
      // 查看view  禁用
      coinList: []
    };
  },
  mounted: function mounted() {},
  created: function created() {
    // // 获取保险公司集合
    // getCompanyList().then(res => {
    //   this.companyList = res
    //   console.log('保险公司res', res)
    // })
    // // 获取分支机构
    // getAgencyLisy().then(res => {
    //   console.log('分支机构res', res)
    //   this.attAgencyList = res
    // })
    // 获取币种
    this.getCoinData();
    this.applyFunction();
    this.baseFunction();
    console.log('this.$route.params==', this.$route);
    this.getCountry();

    if (this.$route.params.type == 'view') {
      this.allDisabled = true;
      console.log('查看--');
    }

    if (this.$route.params.type == 'view' || this.$route.params.type == 'edit') {
      this.upLoadFlag = true;
      this.isSureUpload = true;
    }

    if (this.$route.params.userType == '02') {
      this.isUser = true;
      this.userDisable = true;
      console.log('this.userDisable==', this.userDisable);
    }

    console.log('meiyuan复制', this.$route.params.userType);

    if (this.$route.params.userType == '02') {
      console.log('meiyuan复制', this.$route.params.type);

      if (this.$route.params.type == 'edit') {
        if (this.formData.premiumCurrency == '') {
          this.formData.premiumCurrency = 'USD';
          this.formData.premiumCurrencyName = '美元';
        }
      }
    }
  },
  methods: {
    setXEmail: function setXEmail(email) {
      //邮箱 脱敏
      //2022-01-11 判断如果邮箱是多个的话需要特殊处理
      var emailArr = [];

      if (email.search(",") != -1) {
        emailArr = email.split(",");
        var new_email = '';

        for (var j = 0; j < emailArr.length; j++) {
          if (String(emailArr[j]).indexOf('@') > 0) {
            var str = emailArr[j].split('@');
            var _s = '';

            if (str[0].length > 3) {
              //@前面多于3位
              for (var i = 3; i < str[0].length; i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 3) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 3) + _s + '@' + str[1];
              }
            } else {
              //@前面小于等于于3位
              for (var _i = 1; _i < str[0].length; _i++) {
                _s += '*';
              }

              if (new_email != '') {
                new_email = new_email + ',' + str[0].substr(0, 1) + _s + '@' + str[1];
              } else {
                new_email = str[0].substr(0, 1) + _s + '@' + str[1];
              }
            }
          }
        }

        return new_email;
      } else {
        var _new_email = email;

        if (String(email).indexOf('@') > 0) {
          var _str = email.split('@');

          var _s2 = '';

          if (_str[0].length > 3) {
            //@前面多于3位
            for (var _i2 = 3; _i2 < _str[0].length; _i2++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 3) + _s2 + '@' + _str[1];
          } else {
            //@前面小于等于于3位
            for (var _i3 = 1; _i3 < _str[0].length; _i3++) {
              _s2 += '*';
            }

            _new_email = _str[0].substr(0, 1) + _s2 + '@' + _str[1];
          }
        }

        return _new_email;
      }
    },
    setXPhone: function setXPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 4) + "****" + tel.substring(9);
        return str;
      } else {
        var phone = this.formData.applicantInfo.linkmanPhone; //获取到被保人的电话信息

        phone = "" + phone;
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        var phone = phone.replace(reg, "$1****$2");
        this.formData.applicantInfo.linkmanPhone = phone;
        return phone;
      }
    },
    setLinkmanIdeNo: function setLinkmanIdeNo(tel) {
      //证件号码
      if (null != tel && tel != undefined) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 4) + "****" + tel.substring(5);
        return str;
      }
    },
    upLast: function upLast() {
      if (!this.isSureUpload) {
        this.$message({
          type: 'warning',
          message: '请先点击暂存'
        });
      }
    },
    jiaoYanPremium: function jiaoYanPremium() {
      if (this.formData.premiumStart != '') {
        if (this.formData.premiumStart != '' && this.formData.premiumEnd != '') {
          if (Number(this.formData.premiumEnd) < Number(this.formData.premiumStart)) {
            this.prompt('预计保费止不能小于预计保费始');
            return false;
          } else {
            return true;
          }
        } else {
          this.prompt('请输入预计保费止值');
          return false;
        }
      } else {
        this.prompt('请先输入预计保费起始值');
        return false;
      }
    },
    jiaoYan: function jiaoYan(type, value, numType) {
      var reg = /^[1-9]\d*$/;

      if ("firstType" == numType) {
        this.promptData(type, value, this.firstDate.year, this.firstDate.mouth, this.firstDate.day, reg);
      } else {
        this.promptData(type, value, this.secondDate.year, this.secondDate.mouth, this.secondDate.day, reg);
      }
    },
    prompt: function prompt(message) {
      this.$message({
        type: 'warning',
        message: message
      });
    },
    promptData: function promptData(type, value, yearData, monthData, dayData, regExp) {
      if (type == 'year') {
        if (yearData == '' || yearData == undefined) {} else {
          if (regExp.test(value)) {
            var reg = /^\d{4}$/;

            if (reg.test(value)) {
              if (Number(value) < 1900) {
                this.prompt("输入年份需大于1900");
              }
            } else {
              this.prompt("输入年份不能超过四位");
            }
          } else {
            this.prompt("年份请输入数字");
          }
        }
      } else if (type == 'month') {
        if (monthData == '' || monthData == undefined) {} else {
          if (yearData == '' || yearData == undefined) {
            this.prompt("请先输入数据统计截至日期的年份");
          } else {
            if (regExp.test(value)) {
              if (value > 0 && value <= 12) {
                //判断两个数据统计截止日期中录入的日期是否正确
                var firstYear = yearData;
                var firstMonth = monthData;
                var nowDate = new Date(firstYear + '-' + firstMonth);
                var cloneNowDate = new Date(firstYear + '-' + firstMonth);
                var fullYear = nowDate.getFullYear();
                var month = nowDate.getMonth() + 1; // getMonth 方法返回 0-11，代表1-12月

                var endOfMonth = new Date(fullYear, month, 0).getDate(); // 获取本月最后一天

                var endDate = this.getFullDate(cloneNowDate.setDate(endOfMonth)); //当月最后一天

                var startDate = this.getFullDate(cloneNowDate.setDate(1)); //当月第一天

                this.prompt('日请输入' + startDate + '-' + endDate);
              } else {
                this.prompt("月份只能输入1-12");
              }
            } else {
              this.prompt("月份请输入数字");
            }
          }
        }
      } else {
        if (dayData == '' || dayData == undefined) {} else {
          if (monthData == '' || monthData == undefined) {
            //dayData==''||dayData ==undefined  monthData==''||monthData ==undefined  yearData==''||yearData ==undefined
            this.prompt("请先输入数据统计截至日期的月份");
          } else {
            if (yearData == '' || yearData == undefined) {
              this.prompt("请先输入数据统计截至日期的年份");
            } else {
              if (regExp.test(value)) {
                if (value > 0 && value <= 31) {} else {
                  this.prompt("日只能输入1-31");
                }
              } else {
                this.prompt("日请输入数字");
              }
            }
          }
        }
      }
    },
    promptDate: function promptDate(year, month, day) {
      var nowDate = new Date(year + '-' + month);
      var cloneNowDate = new Date(year + '-' + month);
      var fullYear = nowDate.getFullYear();
      var mouth = nowDate.getMonth() + 1; // getMonth 方法返回 0-11，代表1-12月

      var endOfMonth = new Date(fullYear, month, 0).getDate(); // 获取本月最后一天

      var endDate = this.getFullDate(cloneNowDate.setDate(endOfMonth)); //当月最后一天

      var startDate = this.getFullDate(cloneNowDate.setDate(1)); //当月第一天

      if (Number(startDate) <= Number(day) && Number(day) <= Number(endDate)) {
        console.log(year + '-' + month + '-' + day);
        return true;
      } else {
        console.log(year + '-' + month + '-' + day);
        return false;
      }
    },
    isEmpty: function isEmpty(year, month, day) {
      if (year == "" && month == "" && day == "") {
        return true;
      } else if (year != "" && month != "" && day != "") {
        return true;
      } else {
        return false;
      }
    },
    getFullDate: function getFullDate(targetDate) {
      var D, y, m, d;

      if (targetDate) {
        D = new Date(targetDate);
        y = D.getFullYear();
        m = D.getMonth() + 1;
        d = D.getDate();
      } else {
        y = fullYear;
        m = month;
        d = date;
      }

      m = m > 9 ? m : m;
      d = d > 9 ? d : d;
      return d;
    },
    numberAdd: function numberAdd(arg1, arg2) {
      var r1, r2, m, n;

      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }

      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }

      m = Math.pow(10, Math.max(r1, r2));
      n = r1 >= r2 ? r1 : r2;
      return ((arg1 * m + arg2 * m) / m).toFixed(n);
    },
    addUpload_1: function addUpload_1(type) {
      if (this.isSureUpload) {
        console.log('制度附件的出口附件00', type);
        this.otherDatas_1.type = type;
        this.otherDatas_1.applicationNo = this.formData.applicationNo;
        this.otherDatas_1.insuranceCompanyCode = this.formData.insuranceCompanyCode;
        this.otherDatas_1.insuranceCompanyName = this.formData.insuranceCompanyName;
        console.log('制度附件的需求号this.otherDatas.applicationNo', this.otherDatas_1.applicationNo);
      } else {
        this.$message({
          type: 'warning',
          message: '请先点击暂存'
        });
        this.electActive = true;
      }
    },
    upOthers: function upOthers(type) {
      if (this.isSureUpload) {
        console.log('上传附件的出口附件', type);
        this.otherDatas.type = type;
        this.otherDatas.applicationNo = this.formData.applicationNo;
        this.otherDatas.insuranceCompanyCode = this.formData.insuranceCompanyCode;
        this.otherDatas.insuranceCompanyName = this.formData.insuranceCompanyName;
        console.log('上传附件的需求号this.otherDatas.applicationNo', this.otherDatas.applicationNo);
      } else {
        this.$message({
          type: 'warning',
          message: '请先点击暂存'
        });
      }
    },
    changeFile: function changeFile(file) {
      console.log('fil1111', file);
      this.fileList.push(file);
      console.log('this.fileList22--', this.fileList);
    },
    httpRequest: function httpRequest(data) {
      console.log('data==', data);
    },
    // 预览文件
    look_img: function look_img(file) {
      var data = {};
      console.log("***********************", file);

      if (file.fileSrc) {
        data = {
          fileSrc: file.fileSrc
        };
        excleCargoDownload_biaodi(data).then(function (res) {
          var blob = new Blob([res], {
            type: ""
          });
          var url = window.URL.createObjectURL(blob);
          console.log(url);
          var link = document.createElement("a"); // 创建a标签

          link.href = url;
          link.download = file.name; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      } else {
        console.log('11111111', file.response.detailDtoList[0].fileSrc);
        var fileSrc = file.response.detailDtoList[0].fileSrc;
        excleCargoDownload_biaodi({
          fileSrc: fileSrc
        }).then(function (res) {
          var blob = new Blob([res], {
            type: ""
          });
          var url = window.URL.createObjectURL(blob);
          console.log('url11111111111', url);
          var link = document.createElement("a"); // 创建a标签

          link.href = url;
          link.download = file.name; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      }
    },
    beforeUploadimg_1: function beforeUploadimg_1(file) {
      var _this = this;

      console.log('file--', file); // this.fileList_1.push(file)

      var mimes = {
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        pdf: 'application/pdf',
        doc: 'application/msword',
        docs: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png'
      };
      return new Promise(function (resolve, reject) {
        var isJPG = file.type === 'image/jpeg';
        var isPNG = file.type === 'image/png';

        if (!_this.isSureUpload) {
          _this.$message.error("\u8BF7\u5148\u70B9\u51FB\u6682\u5B58");

          return reject();
        }

        var flag = false;

        if (file.type == mimes.pdf || file.type == mimes.doc || file.type == mimes.docs) {
          flag = true;
        }

        if (!flag) {
          _this.$message.error("\u4E0A\u4F20\u7684\u6587\u4EF6\u53EA\u80FD\u662Fpdf/word\u683C\u5F0F!");

          return reject();
        }

        var isLt2M = file.size / 1024 / 1024 < 5;
        var isold = true;
        var isnumber = true; //判断文件名是否重复

        var count = 0;

        _this.fileList_1.forEach(function (item, idx) {
          if (idx > 19) {
            isnumber = false;
          }

          if (file.name == item.name) {
            count++;

            if (count == 1) {
              isold = true;
            }

            if (count === 2) {
              isold = false;
            }
          }
        });

        if (!isold) {
          _this.$message({
            message: '上传文件已存在，请确认后重新上传!',
            type: 'warning'
          });
        }

        if (!isLt2M) {
          _this.$message({
            message: '上传文件大小不能超过 5MB!',
            type: 'warning'
          });

          _this.fileList_1 = [];
          console.log('文件置空==');
          return reject();
        }

        if (!isnumber) {
          _this.$message({
            message: '最多支持上传20个文件!',
            type: 'warning'
          });
        }

        resolve();
      });
    },
    beforeUploadimg_4: function beforeUploadimg_4(file) {
      var _this2 = this;

      console.log('fileListOthers--', file); // this.fileList_1.push(file)

      var mimes = {
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        pdf: 'application/pdf',
        doc: 'application/msword',
        docs: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png'
      };
      return new Promise(function (resolve, reject) {
        var isJPG = file.type === 'image/jpeg';
        var isPNG = file.type === 'image/png';

        if (!_this2.isSureUpload) {
          _this2.$message.error("\u8BF7\u5148\u70B9\u51FB\u6682\u5B58");

          return reject();
        } // let flag = false
        // if(file.type == mimes.pdf || file.type == mimes.doc || file.type == mimes.docs){
        //   flag = true
        // }
        // if(!flag) {
        //   this.$message.error(`上传的文件只能是pdf/word格式!`)
        //   return reject()
        // }


        var isLt2M = file.size / 1024 / 1024 < 5;
        var isold = true;
        var isnumber = true; //判断文件名是否重复

        var count = 0;

        _this2.fileListOthers.forEach(function (item, idx) {
          if (idx > 19) {
            isnumber = false;
          }

          if (file.name == item.name) {
            count++;

            if (count == 1) {
              isold = true;
            }

            if (count === 2) {
              isold = false;
            }
          }
        });

        if (!isold) {
          _this2.$message({
            message: '上传文件已存在，请确认后重新上传!',
            type: 'warning'
          });

          return reject();
        }

        if (!isLt2M) {
          _this2.$message({
            message: '上传文件大小不能超过 5MB!',
            type: 'warning'
          });

          _this2.fileListOthers = [];
          console.log('文件置空==');
          return reject();
        }

        if (!isnumber) {
          _this2.$message({
            message: '最多支持上传20个文件!',
            type: 'warning'
          });

          return reject();
        }

        resolve();
      });
    },
    beforeUploadimg: function beforeUploadimg(file) {
      console.log('file900--', file);
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; //判断文件名是否重复

      var count = 0;
      this.fileList.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    beforeUploadimgExport: function beforeUploadimgExport(file) {
      console.log('filec出口--', file);
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; //判断文件名是否重复

      var count = 0;
      this.fileListExport.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    beforeUploadimgs: function beforeUploadimgs(file) {
      console.log('file--', file);
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; //判断文件名是否重复

      var count = 0;
      this.fileLists.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    //图片删除时
    handleRemove: function handleRemove(file, fileList) {
      var _this3 = this;

      console.log('基础信息的file', file);
      this.fileList = fileList;

      if (file.imagCode) {
        deleteUpLoads({
          imagCode: file.imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this3.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this3.fileList = fileList;
          }
        });
      }

      if (file.response.detailDtoList[0].imagCode) {
        deleteUpLoads({
          imagCode: file.response.detailDtoList[0].imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this3.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this3.fileList = fileList;
          }
        });
      }
    },
    handleRemove_1: function handleRemove_1(file, fileList) {
      var _this4 = this;

      console.log('文件管理制度的file', file);

      if (file.imagCode) {
        deleteUpLoads({
          imagCode: file.imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this4.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this4.fileList_1 = fileList;
          }
        });
      }

      if (file.response.detailDtoList[0].imagCode) {
        deleteUpLoads({
          imagCode: file.response.detailDtoList[0].imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this4.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this4.fileList_1 = fileList;
            console.log('this.fileList===11', _this4.fileList_1);
          }
        });
      }
    },
    //图片删除时
    handleRemoves: function handleRemoves(file, fileList) {
      var _this5 = this;

      console.log('投保范围file', file);
      console.log('投保范围fileList', fileList);
      this.fileLists = fileList;

      if (file.imagCode) {
        deleteUpLoads({
          imagCode: file.imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this5.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this5.fileLists = fileList;
          }
        });
      }

      if (file.response.detailDtoList[0].imagCode) {
        deleteUpLoads({
          imagCode: file.response.detailDtoList[0].imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this5.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this5.fileLists = fileList;
          }
        });
      }
    },
    handleRemoveExport: function handleRemoveExport(file, fileList) {
      var _this6 = this;

      console.log('出口范围file', file);
      console.log('出口fileList', fileList);
      this.fileListExport = fileList;

      if (file.imagCode) {
        deleteUpLoads({
          imagCode: file.imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this6.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this6.fileListExport = fileList;
          }
        });
      }

      if (file.response.detailDtoList[0].imagCode) {
        deleteUpLoads({
          imagCode: file.response.detailDtoList[0].imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this6.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this6.fileListExport = fileList;
          }
        });
      }
    },
    //图片删除时
    handleRemoveOthers: function handleRemoveOthers(file, fileList) {
      var _this7 = this;

      console.log('出口file', file);

      if (file.imagCode) {
        deleteUpLoads({
          imagCode: file.imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this7.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this7.fileListOthers = fileList;
          }
        });
      }

      if (file.response.detailDtoList[0].imagCode) {
        deleteUpLoads({
          imagCode: file.response.detailDtoList[0].imagCode
        }).then(function (res) {
          if (res.rtnCode == "0000") {
            _this7.$message({
              type: 'success',
              message: res.rtnMsg
            });

            _this7.fileListOthers = fileList;
          }
        });
      }
    },
    //图片上传成功后
    success_img: function success_img(response, file, fileList) {
      console.log('fileList====', fileList);
      this.fileList = fileList;
    },
    success_img_1: function success_img_1(response, file, fileList) {
      console.log('response====', response);
      console.log('file====', file);
      console.log('fileList====', fileList);

      if (response.rtnCode == '0000') {
        this.hasUplaod = true;
      }

      this.fileList_1 = file;
      console.log('this.fileList_1====', this.fileList_1);
    },
    //图片上传成功后
    success_imgs: function success_imgs(response, file, fileList) {
      this.fileLists = fileList;
      console.log('this.fileLists====', this.fileLists);
    },
    success_imgExport: function success_imgExport(response, file, fileList) {
      this.fileListExport = fileList;
      console.log('this.fileListExport====', this.fileListExport);
    },
    // 上传文件
    submitUpload: function submitUpload(type) {
      var _this8 = this;

      console.log('上传文件的type', type);
      var j = 0;
      var newarray = [];
      var dataFile = new FormData();

      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].raw && this.fileList[i].type != "old") {
          if (j < 10) {
            dataFile.append('files', this.fileList[i].raw);
            this.fileList[i]['type'] = 'old';
          }

          j++;
        }
      }

      dataFile.append('type', type);
      dataFile.append('applicationNo', this.formData.applicationNo);
      dataFile.append('insuranceCompanyCode', this.formData.insuranceCompanyCode);
      dataFile.append('insuranceCompanyName', this.formData.insuranceCompanyName);
      upLoads(dataFile).then(function (res) {
        console.log('res影像上传成功后的结果', res);

        if (res.rtnCode == "0000") {
          var k = 0;

          for (var i = 0; i < _this8.fileList.length; i++) {
            // console.log(this.fileList)
            if (!_this8.fileList[i].imagCode && k < 10) {
              _this8.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
              _this8.fileList[i].imagCode = res.detailDtoList[k].imagCode;
              _this8.fileList[i].applicationNo = res.detailDtoList[k].applicationNo;
              newarray.push(_this8.fileList[i]);
              k++;
            }
          }

          console.log('newarray.length', newarray.length);

          if (newarray.length > 9) {
            // console.log("00000",this.fileList.length)
            _this8.submitUpload2();
          } else {
            _this8.$message({
              duration: 3000,
              message: res.data,
              type: 'success'
            });

            $(".el-upload-list__item-status-label").css("display", "block");
          }
        } else {
          _this8.$message({
            duration: 3000,
            message: '没有待上传的影像',
            type: 'error'
          });
        }
      });
    },
    // 上传文件--出口
    submitUploadExport: function submitUploadExport(type) {
      var _this9 = this;

      console.log('出口的type', type);
      var j = 0;
      var newarray = [];
      var dataFile = new FormData();
      console.log('出口的this.fileListExport', this.fileListExport);

      for (var i = 0; i < this.fileListExport.length; i++) {
        if (this.fileListExport[i].raw && this.fileListExport[i].type != "old") {
          if (j < 10) {
            dataFile.append('files', this.fileListExport[i].raw);
            this.fileListExport[i]['type'] = 'old';
          }

          j++;
        }
      }

      dataFile.append('type', type);
      dataFile.append('applicationNo', this.formData.applicationNo);
      dataFile.append('insuranceCompanyCode', this.formData.insuranceCompanyCode);
      dataFile.append('insuranceCompanyName', this.formData.insuranceCompanyName);

      if (!this.formData.applicationNo || !this.formData.insuranceCompanyName || !this.formData.insuranceCompanyCode) {
        this.$message({
          duration: 3000,
          message: '没有待上传的影像',
          type: 'error'
        });
        return false;
      }

      upLoads(dataFile).then(function (res) {
        console.log('res影像上传成功后的结果', res);

        if (res.rtnCode == "0000") {
          var k = 0;

          for (var i = 0; i < _this9.fileList.length; i++) {
            // console.log(this.fileList)
            if (!_this9.fileListExport[i].imagCode && k < 10) {
              _this9.fileListExport[i].fileSrc = res.detailDtoList[k].fileSrc;
              _this9.fileListExport[i].imagCode = res.detailDtoList[k].imagCode;
              _this9.fileListExport[i].applicationNo = res.detailDtoList[k].applicationNo;
              newarray.push(_this9.fileListExport[i]);
              k++;
            }
          }

          console.log('newarray.length', newarray.length);

          if (newarray.length > 9) {
            // console.log("00000",this.fileList.length)
            _this9.submitUpload2();
          } else {
            _this9.$message({
              duration: 3000,
              message: res.data,
              type: 'success'
            });

            $(".el-upload-list__item-status-label").css("display", "block");
          }
        } else {
          _this9.$message({
            duration: 3000,
            message: '没有待上传的影像',
            type: 'error'
          });
        }
      });
    },
    // 上传文件--投保范围
    submitUploads: function submitUploads(type) {
      var _this10 = this;

      console.log('投保范围的type', type);
      var j = 0;
      var newarray = [];
      var dataFile = new FormData();
      console.log('投保范围的this.fileLists', this.fileLists);

      for (var i = 0; i < this.fileLists.length; i++) {
        if (this.fileLists[i].raw && this.fileLists[i].type != "old") {
          if (j < 10) {
            dataFile.append('files', this.fileLists[i].raw);
            this.fileLists[i]['type'] = 'old';
          }

          j++;
        }
      }

      dataFile.append('type', type);
      dataFile.append('applicationNo', this.formData.applicationNo);
      dataFile.append('insuranceCompanyCode', this.formData.insuranceCompanyCode);
      dataFile.append('insuranceCompanyName', this.formData.insuranceCompanyName);

      if (!this.formData.applicationNo || !this.formData.insuranceCompanyName || !this.formData.insuranceCompanyCode) {
        this.$message({
          duration: 3000,
          message: '没有待上传的影像',
          type: 'error'
        });
        return false;
      }

      upLoads(dataFile).then(function (res) {
        console.log('res影像上传成功后的结果', res);

        if (res.rtnCode == "0000") {
          var k = 0;

          for (var i = 0; i < _this10.fileList.length; i++) {
            // console.log(this.fileList)
            if (!_this10.fileLists[i].imagCode && k < 10) {
              _this10.fileLists[i].fileSrc = res.detailDtoList[k].fileSrc;
              _this10.fileLists[i].imagCode = res.detailDtoList[k].imagCode;
              _this10.fileLists[i].applicationNo = res.detailDtoList[k].applicationNo;
              newarray.push(_this10.fileLists[i]);
              k++;
            }
          }

          console.log('newarray.length', newarray.length);

          if (newarray.length > 9) {
            // console.log("00000",this.fileList.length)
            _this10.submitUpload2();
          } else {
            _this10.$message({
              duration: 3000,
              message: res.data,
              type: 'success'
            });

            $(".el-upload-list__item-status-label").css("display", "block");
          }
        } else {
          _this10.$message({
            duration: 3000,
            message: '没有待上传的影像',
            type: 'error'
          });
        }
      });
    },
    submitUpload2: function submitUpload2() {
      var _thist = this;

      var formData = new FormData();
      formData.append('proposalNo', _thist.ProposalMainDto.proposalNo);
      formData.append('protocolNo', _thist.ProposalMainDto.protocolNo);
      formData.append('insuranceCompanyCode', _thist.ProposalMainDto.insuranceCompanyCode);
      formData.append('insuranceCompanyName', _thist.ProposalMainDto.insuranceCompanyName);

      for (var i = 0; i < _thist.fileList.length; i++) {
        if (_thist.fileList[i].raw && _thist.fileList[i].type != "old") {
          formData.append('files', _thist.fileList[i].raw);
          _thist.fileList[i]['type'] = 'old';
        }
      }

      imageUploads_fun(formData).then(function (res) {
        if (res.rtnCode == "0000") {
          _thist.$message({
            duration: 3000,
            message: res.data,
            type: 'success'
          });

          $(".el-upload-list__item-status-label").css("display", "block");
          var k = 0;

          for (var i = 0; i < _thist.fileList.length; i++) {
            if (!_thist.fileList[i].imagCode) {
              _thist.fileList[i].fileSrc = res.detailDtoList[k].fileSrc;
              _thist.fileList[i].imagCode = res.detailDtoList[k].imagCode;
              _thist.fileList[i].proposalNo = res.detailDtoList[k].proposalNo;
              k++;
            }
          }
        } else {
          _thist.$message({
            duration: 3000,
            message: '没有待上传的影像',
            type: 'error'
          });
        }
      }, function (res) {
        _thist.c = false;
      });
    },
    // 点击影像上传
    upFile: function upFile() {
      this.upLoadFlag = true;
      console.log('点击影像上传');
    },
    changeReason: function changeReason(value) {
      console.log('value==', value);
    },
    changeCoin: function changeCoin(value) {
      var _this11 = this;

      console.log('value', value);
      this.coinList.forEach(function (item) {
        if (item.codeCode == value) {
          _this11.formData.premiumCurrencyName = item.codeCname;
          console.log('this.formData.premiumCurrencyName', _this11.formData.premiumCurrencyName);
        }
      });
    },
    addEndDate: function addEndDate(value) {
      console.log('选择起保日期==', value);
      var newdate = new Date(value);
      newdate = newdate.setFullYear(newdate.getFullYear() + 1);
      var aa = new Date(new Date(newdate).getTime() - 24 * 60 * 60 * 1000);
      this.formData.endDate = aa;
    },
    getCoinData: function getCoinData() {
      var _this12 = this;

      coinData({
        codeLever: 1,
        codeType: ["currency"]
      }).then(function (res) {
        console.log('rres', res);
        _this12.coinList = res[0].dictionary;
      });
    },
    changeDateStart: function changeDateStart(value) {
      var currentDate = this.getCurrentTime(); // 当前日期时间戳

      currentDate = this.getTimes(currentDate);
      var startTime = this.getTimes(value);

      if (startTime < currentDate) {
        this.$message.warning('选择日期应不小于当前日期');
      } else {
        var endTime = this.getEndDate(value, '1年');
        this.formData.insureRange.expectEndDate = endTime;
      }
    },
    getEndDate: function getEndDate(start, section) {
      var end = '';
      var startDate = new Date(start);

      if (section.indexOf('年')) {
        var sec = section.replace('年', '') - 0;
        startDate.setFullYear(startDate.getFullYear() + sec);
      } else if (section.indexOf('月')) {
        var _sec = section.replace('月', '') - 0;

        startDate.setMonth(startDate.getMonth() + _sec);
      } else {
        var _sec2 = section.replace('天', '') - 0;

        startDate.setDate(startDate.getDate() + _sec2);
      }

      startDate.setDate(startDate.getDate() - 1);
      end = this.dateFomat(startDate);
      return end;
    },
    dateFomat: function dateFomat(date) {
      var division = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
      return date.getFullYear() + division + this.supplementZero(date.getMonth() + 1) + division + this.supplementZero(date.getDate());
    },
    supplementZero: function supplementZero(num) {
      return num > 9 ? num : '0' + num;
    },
    changeDateEnd: function changeDateEnd(value) {
      var startTime = this.getTimes(this.formData.insureRange.expectStartDate);
      var endTime = this.getTimes(value);

      if (endTime < startTime) {
        this.$message.warning('选择日期应不小于保险期限起期');
      }
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      var date = time;
      date = date.substring(0, 19);
      date = date.replace(/-/g, "/"); //必须把日期'-'转为'/'

      var timestamp = new Date(date).getTime();
      return timestamp;
    },
    // 获取当前日期
    getCurrentTime: function getCurrentTime() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (day < 10) {
        day = "0" + day;
      }

      var nowDate = year + "-" + month + "-" + day;
      return nowDate;
    },
    validPriceForm: function validPriceForm() {
      // 校验规则
      // 校验基本信息  投保范围 出口情况
      var baseValid = true;
      var rangeValid = false;
      var totalValid = false;
      this.$refs['formData.applicantInfo'].validate(function (valid) {
        if (valid) {
          baseValid = true;
        } else {
          baseValid = false;
        }
      });
      this.$refs['formData.insureRange'].validate(function (valid) {
        if (valid) {
          rangeValid = true;
        } else {
          rangeValid = false;
        }
      });
      this.$refs['formData'].validate(function (valid) {
        if (valid) {
          totalValid = true;
        } else {
          totalValid = false;
        }
      });
      return baseValid && rangeValid && totalValid;
    },
    cancleBtn: function cancleBtn() {
      this.$store.dispatch('delVisitedViews', this.$route);
      this.$router.push('/');
    },
    getCountry: function getCountry() {
      var _this13 = this;

      var countryLists = localStorage.getItem('countryList');

      if (countryLists !== null) {
        this.country = JSON.parse(countryLists);
      } else {
        _getCountry({}).then(function (res) {
          if (res.rtnCode == '0000') {
            _this13.country = res.countryList;
            localStorage.setItem('countryList', JSON.stringify(res.countryList));
          } else {
            _this13.$message({
              type: 'error',
              message: res.rtnMsg
            });
          }
        });
      }
    },
    // 合计--逾期应收款
    getTotals: function getTotals(param) {
      var _this14 = this;

      // console.log('是否进入')
      // console.log('param1=',param)
      var columns = param.columns,
          data = param.data; // console.log('columns1=',columns)
      // console.log('data1=',data)

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '';
          return;
        }

        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        if (index === 5) {
          sums[index] = '';
          return;
        }

        if (index === 4) {
          sums[index] = '';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        }); // console.log('values1=',values)

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return _this14.numberAdd(prev, curr);
            } else {
              return prev;
            }
          }, 0);

          if (index == '2') {
            sums[index] += ' 美元';
          } else if (index == '3') {
            sums[index] += ' %';
          }
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[0] = ''; // console.log('sums1=',sums)

      return sums;
    },
    // 合计--应收账款余额分布
    getSummaries: function getSummaries(param) {
      var _this15 = this;

      console.log('param=', param);
      var columns = param.columns,
          data = param.data;
      console.log('columns=', columns);
      console.log('data=', data);
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '';
          return;
        }

        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        console.log('values=', values);

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return _this15.numberAdd(prev, curr);
            } else {
              return prev;
            }
          }, 0);

          if (index == '2') {
            sums[index] += ' ';
          } else {
            sums[index] += ' 美元';
          }
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[0] = '';
      console.log('sums=', sums);
      return sums;
    },
    selectedAll: function selectedAll(arr) {
      var _this16 = this;

      // 选择的投保范围
      // 如果是全选
      if (arr.length == 5) {
        arr.forEach(function (item1) {
          if (item1.codeCode == '4') {
            _this16.$refs.multipleTable.toggleRowSelection(item1, false);
          }
        });
      }

      this.checkedItem = arr;
      console.log('this.checkedItem2', this.checkedItem);
    },
    selectedItem: function selectedItem(arr) {
      // 选择的投保范围
      this.checkedItem = arr;
      console.log('this.checkedItem1', this.checkedItem);
    },
    cellClass: function cellClass(row) {
      if (this.allDisabled || this.userDisable) {
        if (row.columnIndex == 2) {
          return 'DisableSelection';
        }
      }
    },
    checkCode: function checkCode(row, rowIndex) {
      if (this.allDisabled || this.userDisable) {
        return false;
      }

      var check1 = true;

      if (rowIndex == 3) {
        this.checkedItem.forEach(function (item) {
          if (item.codeCode == '1') {
            check1 = false;
          }
        });
      } else if (rowIndex == 0) {
        this.checkedItem.forEach(function (item) {
          if (item.codeCode == '4') {
            check1 = false;
          }
        });
      }

      return check1;
    },
    baseFunction: function baseFunction() {
      var _this17 = this;

      // 获取基础数据下拉列表的值
      baseInfo({}).then(function (res) {
        console.log('res结果', res);

        if (res.rtnCode === '0000') {
          _this17.businessNatures = res.businessNature;
          _this17.identifyType = res.personIdentifyType;
          _this17.companyType = res.companyType;
        }
      });
    },
    // 初始化的数据
    applyFunction: function applyFunction() {
      var _this18 = this;

      applyInfo({}).then(function (res) {
        console.log('res申请人信息', res);

        if (res.rtnCode === '0000') {
          _this18.formData.applicantInfo.companyDate = res.companyDate;
          _this18.formData.applicantInfo.businessStartDate = res.businessStartDate;
          _this18.formData.applicantInfo.businessEndDate = res.businessEndDate;
          _this18.formData.applicantInfo.insuredName = res.insuredName;
          _this18.formData.applicantInfo.insuredEnName = res.insuredEnName;
          _this18.formData.applicantInfo.identifyNumber = res.identifyNumber;
          _this18.formData.applicantInfo.authPersonName = res.authPersonName;
          _this18.formData.applicantInfo.authPersonName = res.authPersonName;
          _this18.formData.applicantInfo.authPersonIdeType = res.authPersonIdeType;
          _this18.formData.applicantInfo.authPersonIdeNo = res.authPersonIdeNo;
          _this18.formData.applicantInfo.businessRange = res.businessRange;
          _this18.formData.applicantInfo.linkmanName = res.linkmanName;
          _this18.formData.applicantInfo.linkmanPhone = res.linkmanPhone;
          _this18.formData.applicantInfo.linkmanIdeNo = res.linkmanIdeNo;
          _this18.formData.applicantInfo.linkmanEmail = res.linkmanEmail;
          _this18.formData.applicantInfo.linkmanIdeType = res.linkmanIdeType;
          _this18.formData.applicantInfo.isListed = res.isListed;
          _this18.formData.applicantInfo.businessType = res.businessType;
          _this18.formData.applicantInfo.companyType = res.companyType;
          _this18.formData.applicantInfo.registAddress = res.registAddress;
          _this18.formData.applicantInfo.businessAddress = res.businessAddress;
          _this18.formData.applicantInfo.businessStartYear = res.businessStartYear;
          _this18.formData.applicantInfo.businessScope = res.businessScope;
          _this18.formData.applicantInfo.businessNature = res.businessNature;
          _this18.formData.lastTreYearBus = res.lastTreYearBus;
          console.log('res.lastTreYearBus==', res.lastTreYearBus);
          console.log('this.formData.lastTreYearBus22==', _this18.formData.lastTreYearBus);
          _this18.formData.insuranceCompanyName = res.insuranceCompanyName;
          _this18.formData.insuranceCompanyCode = res.insuranceCompanyCode;
          _this18.formData.companyName = res.companyName;
          _this18.formData.companyType = res.companyType;
          _this18.insureRange = res.insureRange;
          _this18.formData.lastRec = res.lastYearRec;
          _this18.formData.lastAllRec = res.receivableRange; // let differ = res.resolveWay[0].codeCname
          // let detail = res.resolveWay[1].codeCname
          // console.log('differ',differ)
          // console.log('detail',detail)
          // let obj = {}
          // obj.differ = differ
          // obj.detail = detail
          // this.resolveWay.push(obj)
          // console.log('this.resolveWay==',this.resolveWay)

          res.overDueDays.forEach(function (item) {
            item.overDueDaysName = item.codeCname;
          });
          _this18.formData.overDue = res.overDueDays; // console.log('this.formData.overDue',this.formData.overDue)

          _this18.formData.lastTreUnCollect = res.lastTreUnCollect; // this.getFour()

          if (_this18.$route.params.type == 'view' || _this18.$route.params.type == 'edit') {
            console.log('查看/修改---');

            if (_this18.$route.params.type == 'edit') {
              _this18.formData.operateType = '2';
            }

            if (_this18.$route.params.type == 'view') {
              _this18.allDisabled = true;
            }

            _this18.formData.applicationNo = _this18.$route.params.applicationNo;

            _this18.getList();
          }

          if (_this18.$route.params.type == 'view') {
            //电话脱敏
            if (_this18.formData.applicantInfo.linkmanPhone != null && _this18.formData.applicantInfo.linkmanPhone != '') {
              _this18.formData.applicantInfo.linkmanPhone = _this18.setXPhone(_this18.formData.applicantInfo.linkmanPhone);
            } //邮箱脱敏


            if (_this18.formData.applicantInfo.linkmanEmail != null && _this18.formData.applicantInfo.linkmanEmail != '') {
              _this18.formData.applicantInfo.linkmanEmail = _this18.setXEmail(_this18.formData.applicantInfo.linkmanEmail);
            } //证件号码脱敏


            if (_this18.formData.applicantInfo.linkmanIdeNo != null && _this18.formData.applicantInfo.linkmanIdeNo != '') {
              _this18.formData.applicantInfo.linkmanIdeNo = _this18.setLinkmanIdeNo(_this18.formData.applicantInfo.linkmanIdeNo);
            }
          }
        }

        getApplicantInfo().then(function (res) {
          console.log('res--', res);
          var userId = res.userId;
          var data = {
            userId: userId,
            businessType: '101'
          };
          getCheckVerifyPermissions(data).then(function (res) {
            console.log('权限验证返回信息', res);

            if (res) {
              if (res.resultCode != '0000') {
                _this18.formData.insuranceCompanyName = '';
              }
            }
          });
        });
      });
    },
    addThird: function addThird() {
      var length = this.formData.maxUnCollect.length;
      this.formData.maxUnCollect.push({
        // 最大几笔逾期未收汇详情
        serialNo: length === 0 ? 1 : length + 1,
        uncollectedDate: '',
        // 时间
        debtorName: '',
        // 债务人全称
        debtorAddress: '',
        // 债务人地址
        countryCode: '',
        // 国家代码
        countryName: '',
        // 国家名称
        overDueAmount: '',
        // 逾期或损失金额（万美元）
        lossReasonCode: '',
        // 损失原因代码
        lossReasonName: '',
        // 损失原因名称
        lossRemark: '' // 备注（处理现状）

      });
      console.log('this.formData.maxUnCollect添加后', this.formData.maxUnCollect);
    },
    addBuyer: function addBuyer() {
      // 手动添加-- 投保主要买方/开证行清单
      var length = this.formData.mainBuyer.length;
      this.formData.mainBuyer.push({
        serialNo: length === 0 ? 1 : length + 1,
        bankName: '',
        // 开户行名称
        buyersName: '',
        // 买方名称
        totalExports: '' // 出口总额（万美元）

      });
      console.log('this.formData.mainBuyer添加后', this.formData.mainBuyer);
    },
    delBuyer: function delBuyer(index, row) {
      console.log('index--', index);
      console.log('row--', row);
      this.formData.mainBuyer.splice(index, 1);
      console.log('this.formData.mainBuyer删除后', this.formData.mainBuyer);
      this.formData.mainBuyer.map(function (item, index) {
        item.serialNo = index + 1;
      });
    },
    delThird: function delThird(index, row) {
      this.formData.maxUnCollect.splice(index, 1);
      console.log('this.formData.maxUnCollect删除后', this.formData.maxUnCollect);
      this.formData.maxUnCollect.map(function (item, index) {
        item.serialNo = index + 1;
      });
    },
    delRow: function delRow(index, row) {
      this.formData.lastAllSale.splice(index, 1);
      console.log('this.formData.lastAllSale删除后', this.formData.lastAllSale);
      this.formData.lastAllSale.map(function (item, index) {
        item.serialNo = index + 1;
      });
    },
    addSecond: function addSecond() {
      var length = this.formData.lastAllExp.length;
      this.formData.lastAllExp.push({
        serialNo: length === 0 ? 1 : length + 1,
        countryCode: '',
        // 国家代码
        countryName: '',
        // 国家名称
        totalExports: '',
        // 出口总额（万美元）
        preYearTotalExports: '',
        // 预计未来一年出口额（万美元）
        payWayCode: '',
        // 付款方式代码
        payWayName: '',
        // 付款方式名称
        avgAccountPeriod: '' // 平均账期（天）

      });
    },
    delSecond: function delSecond(index, row) {
      this.formData.lastAllExp.splice(index, 1);
      console.log('this.formData.lastAllSale删除后', this.formData.lastAllExp);
      this.formData.lastAllExp.map(function (item, index) {
        item.serialNo = index + 1;
      });
    },
    addButton: function addButton() {
      console.log('11111111');
      var length = this.formData.lastAllSale.length;
      console.log('列表长度', length);
      this.formData.lastAllSale.push({
        serialNo: length === 0 ? 1 : length + 1,
        goodsName: '',
        // 商品名称或服务内容
        salesAmount: '',
        // 销售额（万美元）
        proportion: '',
        // 占比（%）
        preYearSalesAmount: '',
        // 预计未来一年销售额（万美元）
        payWayCode: '',
        // 付款方式代码
        payWayName: '',
        // 非必填 付款方式名称
        avgAccountPeriod: '' // 平均账期（天）

      });
      console.log('this.formData.lastAllSale', this.formData.lastAllSale);
    },
    tempBtn: function tempBtn(index) {
      var _this19 = this;

      console.log('checkedItem', this.checkedItem);
      var ids = [];
      this.checkedItem.forEach(function (item) {
        ids.push(item.codeCode);
      }); // console.log('ids==',ids)

      ids = ids.join(',');
      console.log('ids==a', ids);
      this.formData.insureRange.insuranceRange = ids;
      console.log('index', index);
      this.formData.submitType = index;
      this.formData.lastAllRec.forEach(function (item, index) {
        _this19.formData.lastAllRec[index].dataCountEndDate = _this19.firstDate.year + '-' + _this19.firstDate.mouth + '-' + _this19.firstDate.day;
      });
      this.formData.overDue.forEach(function (item, index) {
        _this19.formData.overDue[index].dataCountEndDate = _this19.secondDate.year + '-' + _this19.secondDate.mouth + '-' + _this19.secondDate.day;
      });
      console.log('暂存/提交this.lastAllRec', this.formData.lastAllRec);

      if (index == '1') {
        // 暂存
        saveInfo(this.formData).then(function (res) {
          console.log('暂存返回的res', res);

          if (res.resultCode === '0000') {
            _this19.isSureUpload = true;
            _this19.formData.applicationNo = res.applicationNo;
            _this19.formData.applidate = res.appliDate;
            _this19.formData.applicationStatus = res.applicationStatus;

            _this19.$message({
              type: 'success',
              message: res.resultMessage
            });
          } else {
            _this19.$message({
              type: 'error',
              message: res.resultMessage
            });
          }
        });
      } else {
        // 提交
        var valid = this.validPriceForm();
        console.log('提交是否为真valid==', valid); // 投保范围部分选其他时，如备注框不录入，提醒信息未显示

        var valid1 = true;
        var newSrr1 = this.formData.insureRange.insuranceRange.split(',');
        newSrr1.forEach(function (temp) {
          if (temp == '5') {
            if (_this19.formData.insureRange.otherCaution == null || _this19.formData.insureRange.otherCaution == '') {
              valid1 = false;
            }
          }
        });

        if (!valid1) {
          this.$message({
            message: '投保范围选其他时，备注框不能为空',
            type: 'error'
          });
          return;
        } //校验数据统计截至日期是否输入，全部输入或者都不输入


        var firstIsEmpty = this.isEmpty(this.firstDate.year, this.firstDate.mouth, this.firstDate.day);
        var secondIsEmpty = this.isEmpty(this.secondDate.year, this.secondDate.mouth, this.secondDate.day);
        console.log('firstIsEmpty=' + firstIsEmpty + 'secondIsEmpty=' + secondIsEmpty);

        if (firstIsEmpty && secondIsEmpty) {
          if (this.firstDate.year != '' && this.firstDate.mouth != '' && this.firstDate.day != '') {
            var firstFlag = this.promptDate(this.firstDate.year, this.firstDate.mouth, this.firstDate.day);

            if (firstFlag) {
              console.log('数据统计截止日期1校验通过');
            } else {
              this.$message({
                message: '数据统计截止日期1输入日期不存在,请检查',
                type: 'error'
              });
              return;
            }

            if (this.secondDate.year != '' && this.secondDate.mouth != '' && this.secondDate.day != '') {
              //校验数据统计截至日期输入是否存在有效
              var secondFlag = this.promptDate(this.secondDate.year, this.secondDate.mouth, this.secondDate.day);

              if (secondFlag) {
                console.log('数据统计截止日期2校验通过');
              } else {
                this.$message({
                  message: '数据统计截止日期2输入日期不存在,请检查',
                  type: 'error'
                });
                return;
              }
            } else {
              console.log('数据统计截止日期2无输入,校验通过');
            }
          } else {
            console.log('数据统计截止日期1无输入,校验通过');

            if (this.secondDate.year != '' && this.secondDate.mouth != '' && this.secondDate.day != '') {
              var _firstFlag = this.promptDate(this.secondDate.year, this.secondDate.mouth, this.secondDate.day);

              if (_firstFlag) {
                console.log('数据统计截止日期2校验通过');
              } else {
                this.$message({
                  message: '数据统计截止日期2输入日期不存在,请检查',
                  type: 'error'
                });
                return;
              }
            } else {
              console.log('数据统计截止日期2无输入,校验通过');
            }
          }
        } else if (!firstIsEmpty) {
          this.$message({
            message: '数据统计截止日期1输入不完整',
            type: 'error'
          });
          return;
        } else if (!secondIsEmpty) {
          this.$message({
            message: '数据统计截止日期1输入不完整',
            type: 'error'
          });
          return;
        }

        console.log('日期校验SUCCESS');

        if (valid) {
          //校验预计保费起始值和止值的大小
          if (this.isUser == true) {
            var flag = this.jiaoYanPremium();

            if (flag) {
              console.log('预计保费校验通过');
            } else {
              return;
            }
          }

          if (this.$route.params.userType == '02') {
            promiseData(this.formData).then(function (res) {
              if (res.rtnCode == '0000') {
                _this19.$message({
                  type: 'success',
                  message: '提交成功'
                });

                _this19.$store.dispatch('delVisitedViews', _this19.$route);

                _this19.$router.push({
                  name: 'insureApplyQuery'
                });
              } else {
                _this19.$message({
                  type: 'success',
                  message: '提交失败'
                });
              }
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            saveInfo(this.formData).then(function (res) {
              console.log('提交返回的res', res);

              if (res.resultCode === '0000') {
                _this19.formData.applicationNo = res.applicationNo;
                _this19.formData.applidate = res.appliDate;
                _this19.formData.applicationStatus = res.applicationStatus;

                _this19.$message({
                  type: 'success',
                  message: res.resultMessage
                });

                _this19.$store.dispatch('delVisitedViews', _this19.$route);

                _this19.$router.push({
                  name: 'customInsureApplyQuery' // insureApplyQuery

                });
              } else {
                _this19.$message({
                  type: 'error',
                  message: res.resultMessage
                });
              }
            });
          }
        } else {
          this.$message({
            message: '页面信息填写有误，请检查。',
            type: 'error'
          });
        }
      }
    },
    getList: function getList() {
      var _this20 = this;

      // 查看数据
      getInfo({
        applicationNo: this.formData.applicationNo
      }).then(function (res) {
        console.log('获取res', res);

        if (res.rtnCode == '0000') {
          // this.fileList = res.generalImageFile
          if (res.generalImageFile && res.generalImageFile.length > 0) {
            for (var i = 0; i < res.generalImageFile.length; i++) {
              var obj = {};
              var formData = new FormData();
              var base64 = 'data:image/png;base64,' + res.generalImageFile[i].base64Src;
              var imagCode = res.generalImageFile[i].imagCode;
              var applicationNo = res.generalImageFile[i].applicationNo;
              var fileSrc = res.generalImageFile[i].fileSrc;
              var fileName = res.generalImageFile[i].fileName; //转换base64到file

              var toFile = require('data-uri-to-file');

              toFile(base64).then(function (filed) {
                console.log(filed.mimeType, filed.data, filed.extension);
                formData.append("imageName", filed);
                obj.raw = filed;
              }); //var file = this.base64ToFile(base64);
              // console.log(file)
              //formData.append("imageName", file);

              obj.name = fileName; //obj.raw = file;

              obj["type"] = "old";
              obj["url"] = base64;
              obj["fileSrc"] = fileSrc;
              obj.imagCode = imagCode;
              obj.applicationNo = applicationNo;

              _this20.fileList.push(obj);

              console.log('获取this.fileList', _this20.fileList);
            }
          }

          if (res.exportImageFile && res.exportImageFile.length > 0) {
            for (var i = 0; i < res.exportImageFile.length; i++) {
              var obj = {};
              var formData = new FormData();
              var base64 = 'data:image/png;base64,' + res.exportImageFile[i].base64Src;
              var imagCode = res.exportImageFile[i].imagCode;
              var applicationNo = res.exportImageFile[i].applicationNo;
              var fileSrc = res.exportImageFile[i].fileSrc;
              var fileName = res.exportImageFile[i].fileName; //转换base64到file

              var _toFile = require('data-uri-to-file');

              _toFile(base64).then(function (filed) {
                console.log(filed.mimeType, filed.data, filed.extension);
                formData.append("imageName", filed);
                obj.raw = filed;
              });

              obj.name = fileName; //obj.raw = file;

              obj["type"] = "old";
              obj["url"] = base64;
              obj["fileSrc"] = fileSrc;
              obj.imagCode = imagCode;
              obj.applicationNo = applicationNo;

              _this20.fileListOthers.push(obj);

              console.log('获取this.fileListOthers', _this20.fileListOthers);
            }
          }

          if (res.insureRangeImageFile && res.insureRangeImageFile.length > 0) {
            for (var i = 0; i < res.insureRangeImageFile.length; i++) {
              var obj = {};
              var formData = new FormData();
              var base64 = 'data:image/png;base64,' + res.insureRangeImageFile[i].base64Src;
              var imagCode = res.insureRangeImageFile[i].imagCode;
              var applicationNo = res.insureRangeImageFile[i].applicationNo;
              var fileSrc = res.insureRangeImageFile[i].fileSrc;
              var fileName = res.insureRangeImageFile[i].fileName; //转换base64到file

              var _toFile2 = require('data-uri-to-file');

              _toFile2(base64).then(function (filed) {
                console.log(filed.mimeType, filed.data, filed.extension);
                formData.append("imageName", filed);
                obj.raw = filed;
              });

              obj.name = fileName; //obj.raw = file;

              obj["type"] = "old";
              obj["url"] = base64;
              obj["fileSrc"] = fileSrc;
              obj.imagCode = imagCode;
              obj.applicationNo = applicationNo;

              _this20.fileLists.push(obj);

              console.log('获取this.fileLists', _this20.fileLists);
            }
          }

          if (res.exportFJFile && res.exportFJFile.length > 0) {
            for (var i = 0; i < res.exportFJFile.length; i++) {
              var obj = {};
              var formData = new FormData();
              var base64 = 'data:image/png;base64,' + res.exportFJFile[i].base64Src;
              var imagCode = res.exportFJFile[i].imagCode;
              var applicationNo = res.exportFJFile[i].applicationNo;
              var fileSrc = res.exportFJFile[i].fileSrc;
              var fileName = res.exportFJFile[i].fileName; //转换base64到file

              var _toFile3 = require('data-uri-to-file');

              _toFile3(base64).then(function (filed) {
                console.log(filed.mimeType, filed.data, filed.extension);
                formData.append("imageName", filed);
                obj.raw = filed;
              });

              obj.name = fileName; //obj.raw = file;

              obj["type"] = "old";
              obj["url"] = base64;
              obj["fileSrc"] = fileSrc;
              obj.imagCode = imagCode;
              obj.applicationNo = applicationNo;

              _this20.fileListExport.push(obj);

              console.log('出口获取this.fileLists', _this20.fileListExport);
            }
          }

          if (res.instFile && res.instFile.length > 0) {
            _this20.hasUplaod = true;

            for (var i = 0; i < res.instFile.length; i++) {
              var obj = {};
              var formData = new FormData();
              var base64 = 'data:image/png;base64,' + res.instFile[i].base64Src;
              var imagCode = res.instFile[i].imagCode;
              var applicationNo = res.instFile[i].applicationNo;
              var fileSrc = res.instFile[i].fileSrc;
              var fileName = res.instFile[i].fileName; //转换base64到file

              var _toFile4 = require('data-uri-to-file');

              _toFile4(base64).then(function (filed) {
                console.log(filed.mimeType, filed.data, filed.extension);
                formData.append("imageName", filed);
                obj.raw = filed;
              });

              obj.name = fileName; //obj.raw = file;

              obj["type"] = "old";
              obj["url"] = base64;
              obj["fileSrc"] = fileSrc;
              obj.imagCode = imagCode;
              obj.applicationNo = applicationNo;

              _this20.fileList_1.push(obj);

              console.log('获取this.fileList_1', _this20.fileList_1);
            }
          }

          _this20.formData.policyNo = res.policyNo;
          _this20.formData.premiumCurrency = res.premiumCurrency;
          _this20.formData.premiumCurrencyName = res.premiumCurrencyName;
          console.log('meiyuan复制', _this20.$route.params.userType);

          if (_this20.$route.params.userType == '02') {
            console.log('meiyuan复制', _this20.$route.params.type);

            if (_this20.$route.params.type == 'edit') {
              if (_this20.formData.premiumCurrency == '') {
                _this20.formData.premiumCurrency = 'USD';
                _this20.formData.premiumCurrencyName = '美元';
              }
            }
          }

          _this20.formData.premiumEnd = res.premiumEnd;
          _this20.formData.premiumStart = res.premiumStart;
          _this20.formData.startDate = res.startDate;
          _this20.formData.endDate = res.endDate;
          _this20.formData.applicantInfo.companyDate = res.applicantInfo.companyDate;
          _this20.formData.applicantInfo.businessStartDate = res.applicantInfo.businessStartDate;
          _this20.formData.applicantInfo.businessEndDate = res.applicantInfo.businessEndDate;
          _this20.formData.applicantInfo.insuredName = res.applicantInfo.insuredName;
          _this20.formData.applicantInfo.insuredEnName = res.applicantInfo.insuredEnName;
          _this20.formData.applicantInfo.identifyNumber = res.applicantInfo.identifyNumber;
          _this20.formData.applicantInfo.authPersonName = res.applicantInfo.authPersonName;
          _this20.formData.applicantInfo.authPersonName = res.applicantInfo.authPersonName;
          _this20.formData.applicantInfo.authPersonIdeType = res.applicantInfo.authPersonIdeType;
          _this20.formData.applicantInfo.authPersonIdeNo = res.applicantInfo.authPersonIdeNo;
          _this20.formData.applicantInfo.businessRange = res.applicantInfo.businessRange;
          _this20.formData.applicantInfo.linkmanName = res.applicantInfo.linkmanName;
          _this20.formData.applicantInfo.linkmanPhone = res.applicantInfo.linkmanPhone;
          _this20.formData.applicantInfo.linkmanIdeNo = res.applicantInfo.linkmanIdeNo;
          _this20.formData.applicantInfo.linkmanEmail = res.applicantInfo.linkmanEmail;

          if (_this20.$route.params.type == 'view') {
            if (_this20.formData.applicantInfo.linkmanPhone != null && _this20.formData.applicantInfo.linkmanPhone != '') {
              //电话脱敏
              _this20.formData.applicantInfo.linkmanPhone = _this20.setXPhone(_this20.formData.applicantInfo.linkmanPhone);
            }

            if (_this20.formData.applicantInfo.linkmanEmail != null && _this20.formData.applicantInfo.linkmanEmail != '') {
              //邮箱脱敏
              _this20.formData.applicantInfo.linkmanEmail = _this20.setXEmail(_this20.formData.applicantInfo.linkmanEmail);
            }

            if (_this20.formData.applicantInfo.linkmanIdeNo != null && _this20.formData.applicantInfo.linkmanIdeNo != '') {
              //证件号码脱敏
              _this20.formData.applicantInfo.linkmanIdeNo = _this20.setLinkmanIdeNo(_this20.formData.applicantInfo.linkmanIdeNo);
            }
          }

          _this20.formData.applicantInfo.linkmanIdeType = res.applicantInfo.linkmanIdeType;
          _this20.formData.applicantInfo.isListed = res.applicantInfo.isListed;
          _this20.formData.applicantInfo.businessType = res.applicantInfo.businessType;
          _this20.formData.applicantInfo.companyType = res.applicantInfo.companyType;
          _this20.formData.applicantInfo.registAddress = res.applicantInfo.registAddress;
          _this20.formData.applicantInfo.businessAddress = res.applicantInfo.businessAddress;
          _this20.formData.applicantInfo.businessStartYear = res.applicantInfo.businessStartYear;
          _this20.formData.applicantInfo.businessScope = res.applicantInfo.businessScope;
          _this20.formData.applicantInfo.businessNature = res.applicantInfo.businessNature;
          _this20.formData.lastAllExp = res.lastAllExp;
          _this20.formData.applidate = res.appliDate;
          _this20.formData.applicationStatus = res.applicationStatus;
          _this20.formData.insuranceCompanyName = res.insuranceCompanyName;
          _this20.formData.companyName = res.companyName; // this.insureRange = res.insureRange

          _this20.formData.lastRec = res.lastRec;
          _this20.formData.lastAllRec = res.lastAllRec;

          if (res.lastAllRec[0].dataCountEndDate) {
            var dataCountEndDate = _this20.formData.lastAllRec[0].dataCountEndDate;
            console.log('dataCountEndDate==', dataCountEndDate);
            var arr = [];
            arr = dataCountEndDate.split('-');
            console.log('arr==', arr);
            _this20.firstDate.year = arr[0];
            _this20.firstDate.mouth = arr[1];
            _this20.firstDate.day = arr[2];
          }

          if (res.overDue[0].dataCountEndDate) {
            var _dataCountEndDate = res.overDue[0].dataCountEndDate;
            console.log('dataCountEndDate1==', _dataCountEndDate);
            var _arr = [];
            _arr = _dataCountEndDate.split('-');
            console.log('arr1==', _arr);
            _this20.secondDate.year = _arr[0];
            _this20.secondDate.mouth = _arr[1];
            _this20.secondDate.day = _arr[2];
          }

          _this20.formData.lastTreYearBus = res.lastTreYearBus;
          _this20.formData.lastAllSale = res.lastAllSale; // 最近一个完整会计年度

          _this20.formData.maxUnCollect = res.maxUnCollect;
          _this20.formData.insureRange.insuranceRange = res.insureRange.insuranceRange;
          _this20.formData.insureRange.insuredAmount = res.insureRange.insuredAmount;
          _this20.formData.insureRange.otherCaution = res.insureRange.otherCaution;
          _this20.formData.insureRange.disputeDealWay = res.insureRange.disputeDealWay;
          _this20.formData.insureRange.expectEndDate = res.insureRange.expectEndDate;
          _this20.formData.insureRange.expectStartDate = res.insureRange.expectStartDate;
          _this20.formData.insureRange.insuredOtherCaution = res.insureRange.insuredOtherCaution;
          _this20.formData.applicantAccRevManInst = res.applicantAccRevManInst;
          _this20.formData.mainBuyer = res.mainBuyer;
          console.log('res.lastTreYearBus==', res.lastTreYearBus);
          console.log('this.formData.lastTreYearBus22==', _this20.formData.lastTreYearBus);
          _this20.formData.overDue = res.overDue;
          _this20.formData.lastTreUnCollect = res.lastTreUnCollect;

          var newSrr = _this20.formData.insureRange.insuranceRange.split(',');

          console.log('newSrr', newSrr);

          _this20.insureRange.forEach(function (item) {
            var rows = [];
            newSrr.forEach(function (temp) {
              if (item.codeCode == temp) {
                rows.push(item);
                console.log('ROWS', rows);

                _this20.toggleSelection(rows);
              }
            });
          });

          _this20.getFour();

          console.log('this.checkedItem999', _this20.checkedItem);
        }
      });
    },
    toggleSelection: function toggleSelection(rows) {
      var _this21 = this;

      console.log('rows===', rows);

      if (rows) {
        rows.forEach(function (row) {
          _this21.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleClick: function handleClick() {// console.log('点击')
    },
    getFour: function getFour() {
      var _this22 = this;

      if (this.insureApplyRecord.length > 0) {} else {
        getRecord({
          auditRecordNo: this.formData.applicationNo
        }).then(function (res) {
          if (res.insureApplyRecord.length > 0) {
            _this22.insureApplyRecord = res.insureApplyRecord;
            console.log('获取审核记录', res);
          } else {
            _this22.$message({
              type: 'error',
              message: res.rtnMsg
            });
          }
        });
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.fileList.push(file);
    },
    handlePictureCardPreviews: function handlePictureCardPreviews(file) {
      this.fileLists.push(file);
    },
    handlePictureExport: function handlePictureExport(file) {
      this.fileListExport.push(file);
    },
    beforeAvatarRemove: function beforeAvatarRemove(file, fileList) {
      var _this23 = this;

      console.log('file==删除', file);
      var id = '';

      if (file.isEdit && file.isEdit == '1') {
        id = file.id;
      } else if (file.response) {
        id = file.response.data[0].id;
      } else {
        id = file.uid;
      }

      if (file || file.status == 'success' || file.raw.type == 'application/pdf' || file.raw.type == 'image/jpeg' || file.raw.type == 'image/png') {
        var del = false;
        deleteFile({
          id: id
        }).then(function (res) {
          if (res.code == 200) {
            _this23.$message.success('删除成功');

            del = true;
            return del;
          }
        });
      }
    },
    sucess: function sucess() {},
    deleteImg: function deleteImg() {},
    beforeAvatarUploads: function beforeAvatarUploads() {},
    selectFile: function selectFile() {},
    // 选择归属机构
    affiliationChange: function affiliationChange(staus) {// if(this.protoMageForm.protocolMainDto.affiliationComName) {
      //   this.attAgencyList.forEach((ele, index) => {
      //     if(this.protoMageForm.protocolMainDto.affiliationComName == ele.companyName) {
      //       this.protoMageForm.protocolMainDto.affiliationComCode = ele.companyCode
      //     }
      //   })
      //   if(this.protoMageForm.protocolMainDto.affiliationComCode) {
      //     this.convert(this.protoMageForm.protocolMainDto.affiliationComCode, staus)
      //   }
      // }
    }
  }
};